import React, { Component } from 'react'
import { 
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col,
    Collapse,
    FormGroup,
    Input,
    Label,
    Row,
    Table,
    UncontrolledTooltip
} from 'reactstrap';
import Async from 'react-select/async';
import { isEqual } from 'lodash';
import moment from 'moment';
// Requests
import { getClientsRequest } from 'api/client';
import { getUsersRequest } from 'api/user';
import { 
    deleteClientActionRequest, 
    updateClientActionRequest, 
    getClientActionsRequest 
} from 'api/clientActions';
import { uploadClientActionDocumentRequest } from 'api/image';
// Helpers
import { calcStartEndPage } from 'helpers/pagination';
import { hasPermission } from 'helpers/auth';
import { formatClientActionsStatus } from 'helpers/status';
// Components
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import MaskAsCompleted from 'components/ClientActions/MaskAsCompleted';
// Constants
import { clientActionsStatuses } from '../../constants';
import { getClientRequest } from 'api/client';
import { getUserRequest } from 'api/user';
// Assets
import { ReactComponent as IEye } from '../../assets/icons/eye.svg'
import { ReactComponent as ISlashedEye } from '../../assets/icons/slashedEye.svg'
import { ReactComponent as IClear } from '../../assets/icons/clear.svg'

class ClientActions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            clientActions: [],
            total: 0,
			pages: 0,
			start_page: 0,
			last_page: 0,
			end_page: 9,
            selectedClient: null,
            selectedUser: null,
            filters: {},
            filtersClients: {},
            filtersUsers: {},
            deleteClientAction: '',
            loading: true,
            selectedClientAction: {},
            markAsCompletedLoading: false,
            markAsCompletedError: null,
            isCollapseOpen: true
        }
    };

    componentDidMount() {
        const clientActionFilter = JSON.parse(localStorage.getItem('clientActionFilter')) || this.state.filters;
		if(clientActionFilter.client) {
			getClientRequest(clientActionFilter.client).then(client => {
				this.setState({
					selectedClient: { label: `${client.first_name} ${client.last_name}`, value: client._id, data: client }
				});
			})
		}
		if(clientActionFilter.user) {
			getUserRequest(clientActionFilter.user).then(user => {
				this.setState({
					selectedUser: { label: `${user.first_name} ${user.last_name}`, value: user._id, data: user }
				});
			})
		}
        
        this.setState({
			filters: {...clientActionFilter},
		}, async () => {
			await this.getClientActions();
		});
    }
    
    componentDidUpdate(prevProps, prevState) {
		if(!isEqual(prevState.filters, this.state.filters)) {
			localStorage.setItem('clientActionFilter', JSON.stringify({...this.state.filters}));
		}
	}

    goTo = path => this.props.history.push(path);

    getClientActions = async () => {
        const { filters } = this.state;


        this.setState({loading: true})

		const clientActionsObj = await getClientActionsRequest(filters);
		const clientActions = clientActionsObj.clientActions;

		const total = clientActionsObj.total;
		const pages = Math.ceil(total / filters.limit);
		const last_page = pages - 1;
		const { start_page, end_page } = calcStartEndPage(0, pages);

		this.setState({
			clientActions,
			total,
			pages,
			start_page,
			last_page,
			end_page,
            loading: false
		})
	}

    loadClients = async (search, callback) => {
		const { filtersClients } = this.state;
		this.setState({
			filtersClients: {
				...filtersClients,
				search
			}
		})
		if(search) {
			const clientResponse = await getClientsRequest(filtersClients);
			const clients = clientResponse.clients.map(client => {
				return {
					data: client,
					label: `${client.first_name} ${client.last_name}`,
					value: client._id
				}
			})
			callback(clients);
		}
	}

    loadUsers = async (search, callback) => {
		const { filtersUsers } = this.state;

		this.setState({
			filtersUsers: {
				...filtersUsers,
				search
			}
		})
		if(search) {
            const userResponse = await getUsersRequest(filtersUsers);
			const users = userResponse.users.map(user => {
				return {
					data: user,
					label: `${user.first_name} ${user.last_name}`,
					value: user._id
				}
			})
			callback(users);
		}
	}

    onChangeSelect = (key) => (object) => {
        const { value } = object.target

        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [key]: value
            }
        }), () => this.getClientActions())
    }

    onChangeAsyncSelect = (key) => (object) => {
        const { filters } = this.state;
        let keySelect; 

        switch(key) {
            case 'client':
                keySelect = 'selectedClient'
            break;
            case 'user':
                keySelect = 'selectedUser'
            break;
            default: keySelect = ''
        }

		if(!object) {
            this.setState({
                filters: {...filters, [key]: ""},
				[keySelect]: ''
            }, () => {
                this.getClientActions();
            })
            return;
        }

		this.setState({
			filters: {  
                ...filters,
                [key]: object.value
            },
			[keySelect]: object
		}, () => {
			this.getClientActions();
		})
    }

    openConfirmation = (id) => () => {
		this.setState({
			deleteClientAction: id
		});
		this.deleteConfirmationModal.toggle();
    }

    deleteClientAction = async () => {
		const { deleteClientAction } = this.state;
        await deleteClientActionRequest(deleteClientAction);
        this.getClientActions()
	}

    setClientActionSelected = (clientAction) => {
        const { selectedClientAction } = this.state;

        if(clientAction._id === selectedClientAction._id) {
            this.setState({
                selectedClientAction: {}
            });
        } else {
            this.setState({
                selectedClientAction: clientAction
            });
        }
		
	};

    changeClientActionToCompleted = async (response, documentFile, approvedDate) => {
        const { selectedClientAction } = this.state;
        
        this.setState({
            markAsCompletedLoading: true
        })
        try {

            const documentUrl = await uploadClientActionDocumentRequest(selectedClientAction._id, documentFile);

            selectedClientAction['status'] = 'completed';
            selectedClientAction['recommendation'] = response;
            selectedClientAction['responseFile'] = documentUrl;
            selectedClientAction['respondedAt'] = new Date();
            selectedClientAction['approvedDate'] = approvedDate;

            await updateClientActionRequest(selectedClientAction)

        } catch (err) {
                selectedClientAction['status'] = 'open';
                this.setState({
                    markAsCompletedLoading: false,
                    markAsCompletedError: err
                })
                return;
        }
        
        this.setState({
            markAsCompletedLoading: false,
            selectedClientAction: {}
        })
        await this.markAsCompletedModal.toggle()
        await this.getClientActions()

    }

    openMarkAsCompletedModal = () => {
		this.markAsCompletedModal.toggle();
	}

    collapseHandler = () => {
        this.setState(prevState => ({
            isCollapseOpen: !prevState.isCollapseOpen
        }))
    }

    cleanFilters = () => {
        this.setState({
            filters: {
                status: '',
            },
            selectedClient: null,
            selectedUser: null,
        }, this.getClientActions)
    }
    
    render () {
        const {
            clientActions,
            filters,
            selectedClient,
            selectedUser,
            loading,
            selectedClientAction,
            markAsCompletedLoading,
            markAsCompletedError,
            isCollapseOpen
        } = this.state;

        const {
            status
        } = filters;

        return (
            <>
                 <div className="content">
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardHeader>
                                    <Row className='mb-3'>
                                        <Col>
                                            <CardTitle className="d-inline-block" tag="h4">
                                                Client Actions
                                            </CardTitle>
                                        </Col>
                                    </Row>
                                    <Row>
										<Col className="d-flex justify-content-end">
                                            <Button id='show-hide' className="filters-btn" onClick={this.collapseHandler}>
												{isCollapseOpen ? 
													<>
														<ISlashedEye/>
														<UncontrolledTooltip
															delay={0}
															target='show-hide'
														>
															Hide filters
														</UncontrolledTooltip>
													</>
												: 
													<>
														<IEye/>
														<UncontrolledTooltip
															delay={0}
															target='show-hide'
														>
															Show filters
														</UncontrolledTooltip>
													</>
												}
											</Button>
											<Button id="clean" className="filters-btn" onClick={this.cleanFilters}>
												<IClear/>
												<UncontrolledTooltip
													delay={0}
													target='clean'
												>
													Clean filters
												</UncontrolledTooltip>
											</Button>
										</Col>
									</Row>
                                    <Collapse isOpen={isCollapseOpen}>
                                        <Row>
                                            <Col sm="12">
                                                <FormGroup>
                                                    <Label>Client</Label>
                                                    <Async
                                                        clearValue={""}
                                                        value={selectedClient}
                                                        name="client"
                                                        options={[]}
                                                        loadOptions={this.loadClients}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        onChange={this.onChangeAsyncSelect('client')}
                                                        placeholder="Type client name..."
                                                        isClearable={true}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm="12">
                                                <FormGroup>
                                                    <Label>Processed by</Label>
                                                    <Async
                                                        clearValue={""}
                                                        value={selectedUser}
                                                        name="user"
                                                        options={[]}
                                                        loadOptions={this.loadUsers}
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        onChange={this.onChangeAsyncSelect('user')}
                                                        placeholder="Type user name..."
                                                        isClearable={true}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col sm="12">
                                                <FormGroup>
                                                    <Label>Status</Label>
                                                    <Input
                                                        className={status ? "mt-2" : 'mt-2 select__placeholder'}
                                                        value={status}
                                                        type="select"
                                                        onChange={this.onChangeSelect('status')}
                                                    >
                                                        <option value="">Select Status...</option>
                                                        {
                                                            clientActionsStatuses.map(status => {
                                                                return <option key={status} value={status}>{formatClientActionsStatus(status)}</option>
                                                            })
                                                        }
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Collapse>
                                    <Row>
                                        <Col sm='12' className='d-flex justify-content-end mt-3'>
                                            <Button disabled={selectedClientAction._id? false : true} color="primary" onClick={this.openMarkAsCompletedModal}>Mark selected as Completed</Button>
                                            {hasPermission('CreateClientAction') ? <Button color="primary" className="add-btn" onClick={() => this.goTo('/client-action/create')}><i className="tim-icons icon-simple-add" /> Client Action</Button> : null}
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <Table responsive>
                                        <thead className="text-primary">
                                            <tr>
                                                <th></th>
                                                <th>Processed By</th>
                                                <th>Client</th>
                                                <th>Block & Lot</th>
                                                <th>Request</th>
                                                <th>Status</th>
                                                <th>Approved Date</th>
                                                <th className="text-right">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                loading ? 
                                                <tr>
                                                    <td colSpan="12">Loading...</td>
                                                </tr>
                                                :
                                                <>
                                                    {clientActions && clientActions.length > 0 ?
                                                        clientActions.map(clientAction => (
                                                            <tr key={clientAction._id}>
                                                                <td>
                                                                    <input 
                                                                        type="checkbox" 
                                                                        checked={selectedClientAction._id === clientAction._id ? true : false} 
                                                                        disabled={clientAction.status === 'completed' && true} 
                                                                        onChange={() => this.setClientActionSelected(clientAction)}
                                                                    />
                                                                </td>
                                                                <td>{`${clientAction.owner?.first_name} ${clientAction.owner?.last_name}`}</td>
                                                                <td>{`${clientAction.client?.first_name} ${clientAction.client?.last_name}`}</td>
                                                                <td>{clientAction.blockNumber && clientAction.lotNumber ? `B${clientAction.blockNumber} - L${clientAction.lotNumber}` : 'N/A'}</td>
                                                                <td>{clientAction.request || 'N/A'}</td>
                                                                <td>
                                                                    <span className={clientAction.status === "open" ? 'text-success' : 'text-danger'}>
                                                                        {formatClientActionsStatus(clientAction.status)}
                                                                    </span>
                                                                </td>
                                                                <td>{clientAction.approvedDate ? moment(clientAction.approvedDate).format('MM/DD/YYYY') : 'N/A'}</td>
                                                                <td className="text-right">
                                                                    <Button
                                                                        className="btn-link btn-icon"
                                                                        color="success"
                                                                        id={`tooltip-view-${clientAction._id}`}
                                                                        size="sm"
                                                                        onClick={() => this.goTo(`/client-action?id=${clientAction._id}`)}
                                                                    >
                                                                        <i className="tim-icons icon-zoom-split" />
                                                                    </Button>
                                                                    <UncontrolledTooltip
                                                                        delay={0}
                                                                        target={`tooltip-view-${clientAction._id}`}
                                                                    >
                                                                        Details
                                                                    </UncontrolledTooltip>
                                                                    {hasPermission('EditClientAction') ? <> 
                                                                        <Button
                                                                            className="btn-link btn-icon"
                                                                            color="info"
                                                                            id={`tooltip-edit-${clientAction._id}`}
                                                                            size="sm"
                                                                            onClick={() => this.goTo(`/client-action/edit?id=${clientAction._id}`)}
                                                                        >
                                                                            <i className="tim-icons icon-pencil" />
                                                                        </Button>
                                                                        <UncontrolledTooltip
                                                                            delay={0}
                                                                            target={`tooltip-edit-${clientAction._id}`}
                                                                        >
                                                                            Edit
                                                                        </UncontrolledTooltip>
                                                                        <Button
                                                                            className="btn-link btn-icon"
                                                                            color="danger"
                                                                            id={`tooltip-delete-${clientAction._id}`}
                                                                            size="sm"
                                                                            onClick={this.openConfirmation(clientAction._id)}
                                                                        >
                                                                            <i className="tim-icons icon-simple-remove" />
                                                                        </Button>
                                                                        <UncontrolledTooltip
                                                                            delay={0}
                                                                            target={`tooltip-delete-${clientAction._id}`}
                                                                        >
                                                                            Delete
                                                                        </UncontrolledTooltip>
                                                                    </> : null}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    : 
                                                        <tr>
                                                            <td colSpan={6}>There's no client action to show</td>
                                                        </tr>
                                                    }
                                                </>
                                            }
                                        </tbody>
                                    </Table>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <ConfirmationModal
						ref={el => this.deleteConfirmationModal = el}
						title="Delete Client Action?"
						buttons={[
							{ title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
							{ title: 'Delete', className: 'btn-danger-override btn btn-danger', onClick: this.deleteClientAction }
						]}
					>
					    Are you sure you want to delete this client action?
				</ConfirmationModal>
                <MaskAsCompleted 
                    ref={el => this.markAsCompletedModal = el}
                    onSave={this.changeClientActionToCompleted}
                    loading={markAsCompletedLoading}
                    error={markAsCompletedError}
                    selectedClientAction={selectedClientAction}
                />
            </>
        )
    }
}

export default ClientActions;